import { render, staticRenderFns } from "./FooterMenu.vue?vue&type=template&id=163493c8&scoped=true&"
import script from "./FooterMenu.vue?vue&type=script&lang=js&"
export * from "./FooterMenu.vue?vue&type=script&lang=js&"
import style0 from "./FooterMenu.vue?vue&type=style&index=0&id=163493c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163493c8",
  null
  
)

export default component.exports